import script from "./addCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./addCustomer.vue?vue&type=script&setup=true&lang=js"

import "./addCustomer.vue?vue&type=style&index=0&id=21461ff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21461ff0"]])

export default __exports__